export default {
	classifyList: '/admin/forword/product/classify/list/{siteid}',
	productList: '/admin/forword/product/query',
	pageList: '/admin/forword/page/{siteid}', //云建站页面结构
	productListAd: '/admin/forword/product/ad', //获取广告自动化需要的内容

	//上线
	get_ads: '/account/online/get_online/{type}/{automationId}',
	update_ads: '/account/online/update_online/{type}',
	customerlist: '/automation/customerlist',
	add_ads: '/account/online/add_online/{automationId}',
	account_building: '/account/online/account_building/{automationId}/{type}',
	logpage: '/automation/logpage',
	searchStatus: '/automation/automation/status',
	ad_languages: '/account/online/ad_languages',
	statistime: '/automation/statistime',
	addManufactureWord: '/account/online/add_manufacture_word',
	deleteManufactureWord: '/account/online/delete_manufacture_word/{adGroupId}',
	//方案
	addproduct: '/automation/addproduct', //添加产品信息（推广内容）
	getproduct: '/automation/getproduct/{id}', //获取产品信息(推广内容)
	productdetail: '/automation/productdetail', //获取指定产品信息推广资料
	addproductdetail: '/automation/addproductdetail', //添加产品信息推广资料
	generate_keyword: '/account/online/admin/enerate_keyword', //后台端根据链接获取关键词列表
	productkeyword: '/automation/productkeyword', //获取指定产品关键字信息
	addproductkeyword: '/automation/addproductkeyword', //添加产品信息关键字
	getgeotargets: '/geotargets/automation/list', //获取地址列表(自动化上线)
	productregion: '/automation/productregion/{id}', //获取产品地区信息
	addproductregion: '/automation/addproductregion', //添加产品信息地区信息
	productadditional: '/automation/productadditional/{id}', //获取产品附加信息
	addproductadditional: '/automation/addproductadditional', //添加产品附加信息
	productdetailList: '/automation/productdetail/list/{id}', //获取所有的推广资料
	prdkeywordList: '/automation/productkeyword/list/{id}', //获取所有关键字信息
	updatenotice: '/automation/updatenotice/{id}', //更新方案通知
	onlineconfirm: '/automation/onlineconfirm/{id}', //客户上线确认
	customerconfirm: '/automation/send/customer/confirm/{id}', //发送给客户确认
	getPersonnel: '/service/staff', // 服务人员列表
	getstepstatus: '/automation/getstepstatus/{id}', //获取进行步骤
	getgroupList: '/geotargets/automation/group/list', //新户自动化上线地址列表
	geotargetsmatching: '/automation/geotargetsmatching', //地区匹配
	keywordHistorical: '/account/online/generate/keyword_historical', //获取手动关键词的平均每月搜索量、竞争程度
	keywordCheck: '/automation/keywordcheck', //关键词校验
	adLanguage: '/account/online/ad_languages', //获取语言列表
	keywordFoldable: '/account/online/generate_keyword_foldable', //获取关键词助手列表
	updateAdsAutoRegion: '/account/online/update_ads_auto_region', // 更新预算
	/**ai自动化 */
	automaticrequestdata: '/automatic/automaticrequestdata', // 全自动生成结果
	semiautomaticrequestdata: '/automatic/semiautomaticrequestdata', // 半自动生成结果
	getmontagecontent: '/automatic/getmontagecontent', // 获取拼接内容api
	listreturncontent: '/automatic/listreturncontent', // 获取生成历史
	saveselecteddata: '/automatic/saveselecteddata', // 保存选中的数据
};
